"use client"
import dynamic from 'next/dynamic';
const Footer = dynamic(() => import('@/Component/Footer'), { ssr: false });
const Header = dynamic(() => import('@/Component/Header'), { ssr: false });
const FadeInSection = dynamic(() => import('@/Component/Hooks/FadeInSection'), { ssr: false });

import styles from "./VisionPage.module.css";
import React, { useState, useRef, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { visionData } from "@/Component/accordion"
import scroll_icon from "@/assets/Icon/Scroll_Icon.png";
import { useLoading } from "@/Component/LoadingContext";
import Image from "next/image"
const VisionPage = () => {
    const { t } = useTranslation();
    const swiperRefs = useRef([]);
    const [index,setIndex] = useState(0);
        const { updateProgress, show } = useLoading();
        const [loadedImageCount, setLoadedImageCount] = useState(0);
    
    const [isInitalized,setIsInitialized] = useState(false);
    const handleClick = (ci_index) => {
        setIndex(ci_index);
        const el = swiperRefs.current[ci_index];
        const container = el?.parentNode;
      
        if (el && container) {
          const elCenter = el.offsetLeft + el.offsetWidth / 2;
          const scrollLeft = elCenter - container.offsetWidth / 2;
          container.scrollTo({ left: scrollLeft, behavior: "smooth" });
        }
    };

    useEffect(() => {
        const container = swiperRefs.current[0]?.parentNode;
        if (!container) return;

        const handleScroll = () => {
            const center = container.scrollLeft + container.offsetWidth / 2;

            let closestIndex = 0;
            let closestDistance = Infinity;

            swiperRefs.current.forEach((el, i) => {
                if (!el) return;
                const elCenter = el.offsetLeft + el.offsetWidth / 2;
                const distance = Math.abs(center - elCenter);
                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestIndex = i;
                }
            });

            if (closestIndex !== index) {
                setIndex(closestIndex);
            }
        };

        container.addEventListener("scroll", handleScroll, { passive: true });
        return () => container.removeEventListener("scroll", handleScroll);
    }, [index]);
    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => {
                const next = (prev + 1) % visionData.CI.length;
    
                const el = swiperRefs.current[next];
                const container = el?.parentNode;
    
                if (el && container) {
                    const elCenter = el.offsetLeft + el.offsetWidth / 2;
                    const scrollLeft = elCenter - container.offsetWidth / 2;
                    container.scrollTo({ left: scrollLeft, behavior: "smooth" });
                }
    
                return next;
            });
        }, 3000); // 🔁 3초마다 변경
    
        return () => clearInterval(interval);
    }, [index]);
    useEffect(() => {
        show();
        setIsInitialized(true);
    },[]);
      
    return (
        <>
            <div className={styles.page}>
                <Header></Header>
                <div className={styles.vision__container}>
                    <div className={styles.value__title}>
                        <div className={styles.value__main__title}>
                            <span className={styles.title__text}>
                                {t("Header.Detail.About.Value")}
                            </span>
                        </div>

                        <div className={styles.value__main__text}>
                            <span className={styles.main__text}>
                                <Trans i18nKey={"Vision.Title.Description"} components={{ color: <span className={styles.main__text__gradation} /> }}>
                                </Trans>
                            </span>

                        </div>
                        <div className={styles.scroll__btn}>
                                                <Image loading="eager" src={scroll_icon} className={styles.scroll__btn__image} alt="scroll">
                                                </Image>
                                            </div>
                    </div>

                    <div className={styles.value__container}>
                        < div className={styles.value__content}>
                            <FadeInSection className={styles.core__value__container}>
                                <div className={styles.core__value__title}>
                                    <span className={styles.core__value__title__text}>
                                        {t("Vision.Core.Title.Text")}
                                    </span>

                                    <span className={styles.core__value__title__description}>
                                        {t("Vision.Core.Title.Description")}
                                    </span>
                                </div>
                                {visionData.Core.map((element, index) => (
                                    <div className={styles.core__value__colum} key={index} >
                                        <span className={styles.core__value__colum__title}>
                                            {t(element.titleKey)}
                                        </span>
                                        <span className={styles.core__colum__highlight__text}>
                                            <Trans i18nKey={element.highlightKey} components={{ color: <span className={`${styles.core__colum__highlight__text} ${styles[`num${(index + 1)}`]}`}></span> }}>
                                            </Trans>
                                        </span>
                                        <span className={styles.core__value__colum__description}>
                                            {t(element.descriptionKey)}
                                        </span>
                                    </div>
                                ))}


                            </FadeInSection>

                            <FadeInSection className={styles.ci__container}>
                                <div className={styles.ci__title}>
                                    <span className={styles.ci__title__text}>
                                        {t("Vision.CI.Title.Text")}
                                    </span>

                                    <span className={styles.ci__title__description}>
                                        {t("Vision.CI.Title.Description")}
                                    </span>
                                </div>
                                <div className={styles.ci__intro}>
                                    {visionData.CI.map((element, ci_index) => (
                                         <div
                                         ref={(el) => (swiperRefs.current[ci_index] = el)}
                                         key={ci_index}
                                         onClick={() => handleClick(ci_index)}
                                         className={`${styles.ci__swiper__section} ${ci_index === index ? styles.active : ""}`}
                                     >
                                      
                                            <div className={styles.swiper__section__title}>
                                                <span className={styles.swiper__section__text}>
                                                    <Trans i18nKey={element.titleKey} components={{ color: <span className={styles.swiper__section__text__gradation} /> }}>
                                                    </Trans>
                                                </span>
                                            </div>

                                            <div className={styles.swiper__section__description}>
                                                {t(element.descriptionKey)}
                                            </div> 
                                        </div>
                                    ))}
                                </div>
                                <div className={styles.logo}>
                                    {isInitalized && visionData.CI .map((element,ci_index) =>(
                                        <Image loading="eager" src={element.img_url} key={ci_index} className={`${styles.logo__img} ${ci_index == index ? styles.active : ""}`} alt="ci image"
                                        onLoad={() => {
                                            setLoadedImageCount((prev) => {
                                                const updated = prev + 1;
                                                setTimeout(() => {
                                                    const progressData = updated === visionData.CI.length ? 100 : (updated / visionData.CI.length) * 100;
                                                    updateProgress(progressData);
                                                }, 0);
                                                return updated;
                                            })
                                        }} onError={() => {
                                            setLoadedImageCount((prev) => {
                                                const updated = prev + 1;
                                                setTimeout(() => {
                                                    const progressData = updated === visionData.CI.length ? 100 : (updated / visionData.CI.length) * 100;
                                                    updateProgress(progressData);
                                                }, 0);
                                                return updated;
                                            })
                                        }}
                                        >
                                    </Image>
                                    )) }
                                </div>
                            </FadeInSection>
                        </div>
                    </div>
                </div>
                <Footer></Footer>
            </div>
        </>
    );
}

export default VisionPage;
